// File: src/App.jsx

import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Standard Imports
import Dashboard from "./components/AdminDashboard/AdminDashboard.jsx";
import Reports from "./pages/Reports/Reports.jsx";
import Settings from "./pages/settings/settings.jsx";
import Users from "./pages/Users/Users.jsx";
import LoginForm from "./pages/Login/Login.jsx";
import PrivateRoute from "./components/PrivateRoute.jsx";
import CourseControl from "./components/admin/CourseControl.jsx";

// Import the new StatusPage component
import StatusPage from "./StatusPage.jsx"; // <<< NEW IMPORT

const App = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => setSidebarCollapsed((prev) => !prev);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginForm />} />

        {/* Protected Admin Routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard
                collapsed={sidebarCollapsed}
                toggleSidebar={toggleSidebar}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <PrivateRoute>
              <Reports
                collapsed={sidebarCollapsed}
                toggleSidebar={toggleSidebar}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Settings
                collapsed={sidebarCollapsed}
                toggleSidebar={toggleSidebar}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <Users
                collapsed={sidebarCollapsed}
                toggleSidebar={toggleSidebar}
              />
            </PrivateRoute>
          }
        />
        <Route
          path="/course-control"
          element={
            <PrivateRoute>
              <CourseControl
                collapsed={sidebarCollapsed}
                toggleSidebar={toggleSidebar}
              />
            </PrivateRoute>
          }
        />

        {/* CATCH-ALL ROUTE (404/Maintenance Page) */}
        {/* Any unhandled route (e.g., /admin/kjhksdhf) will show the StatusPage */}
        <Route
          path="*"
          element={
            <PrivateRoute>
              <StatusPage
                title="Page Under Improvement" // Custom message for the admin panel
                message="The page you requested is currently undergoing maintenance or does not exist. Please navigate back to the dashboard."
                type="maintenance" // Use 'maintenance' type
                // Pass sidebar props in case the PrivateRoute wraps the whole layout
                collapsed={sidebarCollapsed}
                toggleSidebar={toggleSidebar}
              />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
